export const LanguageService = [
  { label: "Français", code: "fr" },
  { label: "English", code: "en" },
  { label: "Vlaams", code: "nl" },
  //{ label: "Русский", code: "ru" },
  //{ label: "中文", code: "cn" },
];
